import { Map } from 'immutable'
import { PictureSources } from './image'

export const FALLBACK_IMAGE_640 = '/images/video-poster-640w.jpg'
export const FALLBACK_IMAGE_1280 = '/images/video-poster-1280w.jpg'
export const FALLBACK_IMAGE_1920 = '/images/video-poster-1920w.jpg'

export const customImageSizes = [
  '48h',
  '96h',
  '640w',
  '1280w',
  '1280w_original',
  '1920w',
  '2880w',
  // Media
  '400w',
  '400w_original',
  '800w',
  '800w_original',
  '1600w',
  // Quote & Specialists/People
  '300x300',
  '300x300_original',
  '600x600',
  // CTA
  '400x400',
  '400x400_original',
  '800x800',
  // Text-Image
  '300x200',
  '600x400',
  '600x400_original',
  '1200x800',
  // Featured Content
  '375x240',
  '375x240_original',
  '750x480',
  '1500x960',
  // Link Grid
  '640x360',
  '640x360_original',
  '1280x720',
  // Link Grid Centrum
  '400x500',
  '400x500_original',
  '800x1000',
] as const

export const imageSizes = [...customImageSizes, 'full', 'full_original'] as const
export type ImageSize = typeof imageSizes[number]

// Full

export const defaultSrc: ImageSize = 'full'

// Pageheader - Logo
export const pageHeaderLogoSrc: ImageSize = '48h'
export const pageHeaderLogoSrcSet: Map<ImageSize, string> = Map([
  ['48h', '48h'],
  ['96h', '96h'],
])

// CTA

export const ctaSrc: ImageSize = '400x400_original'
export const ctaSrcSet: Map<ImageSize, string> = Map([
  ['400x400', '400w'],
  ['800x800', '800w'],
])

export const ctaSources: Array<PictureSources> = []

// Featured Content

export const featuredContentSrc: ImageSize = '375x240_original'
export const featuredContentSources: Array<PictureSources> = [
  {
    media: '(min-width: 60rem)',
    srcset: Map([
      ['1280w', '1280w'],
      ['1920w', '1920w'],
      ['2880w', '2880w'],
    ]),
    sizes: "100vw",
    type: 'image/webp'
  },
  {
    media: '(min-width: 60rem)',
    sizes: "100vw",
    srcset: Map([
      ['1280w_original', '1280w'],
    ]),
  },
  {
    media: '(max-width: 60rem)',
    srcset: Map([
      ['375x240', '375w'],
      ['750x480', '750w'],
      ['1500x960', '1500w'],
    ]),
    sizes: "100vw",
    type: 'image/webp'
  }
]

// Link grid block

export const linkGridSrc: ImageSize = '640x360_original'
export const linkGridSrcSet: Map<ImageSize, string> = Map([
  ['640x360', '640w'],
  ['1280x720', '1280w'],
])

// Related Content Block
// For lack of a better image size, the link grid image sizes are reused for the related content block, as they fit the required aspect ratio and minimum size.
// In the future, if there is a need for different image sizes for the related content block, new image sizes can be added to the imageSizes array and used here.
// 392x196
// 784x392
export const relatedContentSrc: ImageSize = '640x360_original'
export const relatedContentSet: Map<ImageSize, string> = Map([
  ['640x360', '640w'],
  ['1280x720', '1280w'],
])

// Media

export const mediaContentSrc: ImageSize = '800w_original'
export const mediaContentSrcSet: Map<ImageSize, string> = Map([
  ['400w', '400w'],
  ['800w', '800w'],
  ['1600w', '1600w'],
])

export const mediaFullSrc: ImageSize = '1280w_original'
export const mediaFullSrcSet: Map<ImageSize, string> = Map([
  ['640w', '640w'],
  ['1280w', '1280w'],
  ['1920w', '1920w'],
  ['2880w', '2880w']
])

// Pageheader - Hero

export const pageheaderHeroSrc: ImageSize = '1280w_original'
export const pageheaderHeroSrcSet: Map<ImageSize, string> = Map([
  ['640w', '640w'],
  ['1280w', '1280w'],
  ['1920w', '1920w'],
  ['2880w', '2880w'],
])

// Pageheader - Generic

export const pageheaderGenericSrc: ImageSize = '1280w_original'
export const pageheaderHardcodedSrc: ImageSize = '1280w'
export const pageheaderGenericSrcSet: Map<ImageSize, string> = Map([
  ['640w', '640w'],
  ['1280w', '1280w'],
  ['1920w', '1920w']
])
export const pageheaderGenericSources: Array<PictureSources> = []

// Quote

export const quoteSrc: ImageSize = '300x300_original'
export const quoteSrcSet: Map<ImageSize, string> = Map([
  ['300x300', '300w'],
  ['600x600', '600w'],
])

// Specialists

export const specialistsSrc: ImageSize = '300x300_original'
export const specialistsSrcSet: Map<ImageSize, string> = Map([
  ['300x300', '300w'],
  ['600x600', '600w'],
])

// Text-Image

export const textImageSrc: ImageSize = '600x400_original'
export const textImageSrcSet: Map<ImageSize, string> = Map([
  ['300x200', '300w'],
  ['600x400', '600w'],
  ['1200x800', '1200w'],
])

// Text-Image

export const expandableImageSrc: ImageSize = '600x400'
export const expandableImageSrcSet: Map<ImageSize, string> = Map([
  ['400x400', '400w'],
  ['600x600', '600w'],
  ['800x800', '1200w'],
])

// Search results

export const searchResultsSrc: ImageSize = textImageSrc
export const searchResultsSrcSet: Map<ImageSize, string> = textImageSrcSet

// Highlighted News Block

export const highlightedNewsImageSrc: ImageSize = '600x400_original'
export const highlightedNewsImageSrcSet: Map<ImageSize, string> = Map([
  ['300x200', '300w'],
  ['600x400', '600w'],
  ['1200x800', '1200w'],
])
